import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorCatchService {
  private errorSubject = new Subject<string>();
  errorMessage$ = this.errorSubject.asObservable();

  setError(message: string) {
    // console.log("dsadasdas", message);
    
    this.errorSubject.next(message);
  }
}
